import DevelopmentInfo from './DevelopmentInfo';

export default DevelopmentInfo;
